<template>
  <div class="content">
    <!--    我的资产-->
    <div class="message">
      <div class="flex-between">
        <div class="title">我的资产</div>
        <div class="button" @click="goWithdraw">提现</div>
      </div>
      <div class="list">
        <div class="list-item">
          <div class="number">{{ message.issueOrderNum}}</div>
          <div class="text">已出票订单</div>
          <img class="img" src="@/assets/img/home_bg_cpdd_1.png" alt="">
        </div>
        <div class="list-item" style="background: #FFF2F2;">
          <div class="number" style="color: #FE5A62;">{{ message.payAmount }}</div>
          <div class="text" style="color: #FE5A62;">用户支付(元)</div>
          <img class="img" src="@/assets/img/home_bg_yhzf_2.png" alt="">
        </div>
        <div class="list-item" style="background: #EFFAF7;">
          <div class="number" style="color: #2FC5AD;">{{ message.settleAmount }}</div>
          <div style="display: flex;">
            <div class="text" style="color: #2FC5AD;">结算收入(元)</div>
            <el-popover
              placement="bottom"
              title="提示"
              width="200"
              trigger="click"
              content="电影放映48小时后，订单才进行结算，计入结算收入。">
              <div slot="reference" style="position: relative;z-index: 97;"><img class="icon" style="margin-top: 5px" src="@/assets/img/home_btn_question_2.png" alt=""></div>
            </el-popover>
          </div>
          <img class="img" src="@/assets/img/home_bg_jssr_3.png" alt="">
        </div>
        <div class="list-item" style="background: #EDF6FF;">
          <div class="number" style="color: #3D9EFC;">{{ message.balance }}</div>
          <div class="text" style="color: #3D9EFC;">账户余额(元)</div>
          <img class="img" src="@/assets/img/home_bg_zhye_4.png" alt="">
        </div>
      </div>
      <div class="title">账户管理</div>
      <div class="flex">
        <div class="flex-box">
          <div class="left">
            <img src="@/assets/img/home_icon_wechat.png" alt="">
            <div class="left-message">
              <div class="title">{{message.appNum}}</div>
              <div class="text">授权公众号</div>
            </div>
          </div>
          <div class="right" @click="toOfficial()">
            <div class="right-button"><img src="@/assets/img/home_icon_add.png" alt="">添加公众号</div>
          </div>
        </div>
        <div class="flex-box">
          <div class="left">
            <img src="@/assets/img/home_icon_gzh.png" alt="">
            <div class="left-message">
              <div class="title">{{ message.ticketerNum }}</div>
              <div class="text">授权票务号</div>
            </div>
          </div>
          <div class="right" @click="toTicketIn()">
            <div class="right-button"><img src="@/assets/img/home_icon_add.png" alt="" >添加票务号</div>
          </div>
        </div>
      </div>
    </div>
    <!--    数据分析-->
    <div class="message">
      <div class="title">
        数据分析
      </div>
      <div class="list">
        <div class="list-box">
          <div class="list-box-top">
            <div class="top-text">本月新增会员数</div>
            <div class="top-text">{{ message.monthAddFans }}</div>
          </div>
          <div class="list-box-center">
            <div class="center-num">{{ message.todayAddFans }}<span>个</span></div>
            <div class="center-text" v-if="message.diffAddFans >= 0">今天新增会员 <span>较昨日上升{{ message.diffAddFans }}个</span><img src="@/assets/img/home_icon_arrow_litre.png" alt=""></div>
            <div class="center-text" v-else>今天新增会员 <span style="color: #FF4F76;">较昨日下降{{ message.diffAddFans }}个</span><img src="@/assets/img/home_icon_arrow_drop.png" alt=""></div>
          </div>
        </div>
        <div class="list-box">
          <div class="list-box-top">
            <div class="top-text">本月新增订单数</div>
            <div class="top-text">{{ message.monthAddOrders }}</div>
          </div>
          <div class="list-box-center">
            <div class="center-num">{{ message.todayAddOrders }}<span>件</span></div>
            <div class="center-text" v-if="message.diffAddOrders >= 0">今天订单数 <span>较昨日上升{{ message.diffAddOrders }}件</span><img src="@/assets/img/home_icon_arrow_litre.png" alt=""></div>
            <div class="center-text" v-else>今天订单数 <span style="color: #FF4F76;">较昨日下降{{ message.diffAddOrders }}件</span><img src="@/assets/img/home_icon_arrow_drop.png" alt=""></div>
          </div>
        </div>
        <div class="list-box">
          <div class="list-box-top">
            <div class="top-text">本月结算收入</div>
            <div class="top-text">{{ message.monthSettleAmount }}</div>
          </div>
          <div class="list-box-center">
            <div class="center-num">{{ message.todaySettleAmount }}<span>元</span></div>
            <div class="center-text" v-if="message.diffSettleAmount >= 0">今日佣金 <span>较昨日上升{{ message.diffSettleAmount }}元</span><img src="@/assets/img/home_icon_arrow_litre.png" alt=""></div>
            <div class="center-text" v-else>今日佣金 <span style="color: #FF4F76;">较昨日下降{{ message.diffSettleAmount }}元</span><img src="@/assets/img/home_icon_arrow_drop.png" alt=""></div>
          </div>
        </div>
        <div class="list-box">
          <div class="list-box-top">
            <div class="top-text">本月净利润</div>
            <div class="top-text">{{ message.monthCommission }}</div>
          </div>
          <div class="list-box-center">
            <div class="center-num">{{ message.todayCommission }}<span>元</span></div>
            <div class="center-text" v-if="message.diffCommission >= 0">今日利润 <span>较昨日上升{{ message.diffCommission }}元</span><img src="@/assets/img/home_icon_arrow_litre.png" alt=""></div>
            <div class="center-text" v-else>今日利润 <span style="color: #FF4F76;">较昨日下降{{ message.diffCommission }}元</span><img src="@/assets/img/home_icon_arrow_drop.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-message">
        <div class="bottom-message-top">
          <div class="text">新增用户数</div>
          <div class="select">
            <div class="select-div" :class="isActive == 1?'active':''" @click="selectUser(1)">近7天</div>
            <div class="select-div" :class="isActive == 2?'active':''" @click="selectUser(2)">近15天</div>
          </div>
        </div>
        <div class="echarts-box" id="echartsUser"></div>
      </div>
      <div class="bottom-message">
        <div class="bottom-message-top">
          <div class="text">出票订单数</div>
          <div class="select">
            <div class="select-div" :class="isActiveOrder == 1?'active':''" @click="selectOrder(1)">近7天</div>
            <div class="select-div" :class="isActiveOrder == 2?'active':''" @click="selectOrder(2)">近15天</div>
          </div>
        </div>
        <div class="echarts-box" id="echartsOrder"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import {saasIndex} from "@/javaApi/saasIndex";
const SaasM = new saasIndex()
export default {
  name: "index",
  data() {
    return {
      chartLineUser:undefined,
      chartLineOrder:undefined,
      isActive:1,
      message:'',
      isActiveOrder:1,
      echartsData:'',
      fansTimeList:[],
      orderTimeList:[],
    }
  },
  mounted() {
    this.getIndex()
  },
  methods: {
    // 去提现
    goWithdraw(){
      this.$router.push('/pc/user/accountWithdrawal')
    },
    // 获取首页数据
    getIndex(){
      SaasM.getHomeMessage().then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.message = res.data.data
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
      this.getEchartsMessage()
    },
    // 切换
    selectUser(index){
      this.isActive = index
      this.getEchartsMessage()
    },
    // 切换
    selectOrder(index){
      this.isActiveOrder = index
      this.getEchartsMessage()
    },
    getEchartsMessage(){
      let params = {
        fansType:this.isActive,
        orderType:this.isActiveOrder
      }
      SaasM.getEcharts(params).then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.echartsData = res.data.data
          var arr = []
          var arrOrder = []
          var fansTimeList = []
          var orderTimeList = []
          // 处理用户时间数据的格式
          for(let index in this.echartsData.fansTimeList){
            arr.push(this.echartsData.fansTimeList[index].split('-'))
          }
          for(let index2 in arr){
            fansTimeList.push(arr[index2][1] + '-' +arr[index2][2])
          }
          this.fansTimeList = fansTimeList
          // 处理订单时间数据的格式
          for(let index in this.echartsData.orderTimeList){
            arrOrder.push(this.echartsData.orderTimeList[index].split('-'))
          }
          for(let index2 in arrOrder){
            orderTimeList.push(arrOrder[index2][1] + '-' +arrOrder[index2][2])
          }
          this.orderTimeList = orderTimeList
          console.log(orderTimeList)
          // 开始折线图
          this.chartUser()
          this.chartOrder()
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    chartUser(){
      // 用户数
      this.chartLineUser = echarts.init(document.getElementById('echartsUser'))
      var option;
      option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.fansTimeList,
          axisLabel: {
            interval: 0, //设置间隔为0
            rotate:45
          },
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false,  //刻度线
          },
        },
        tooltip: {
          formatter: function(params) {
            console.log(params)   //打印结果
            return params[0].name + '<br/>' + '新增用户数' + ' : ' + params[0].data + '个'     //根据需要拼接
          },
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'cross' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false, //隐藏y轴
          },
          axisTick: {
            show: false,  //刻度线
          },
        },
        series: [
          {
            data: this.echartsData.fansList,
            type: 'line',
            areaStyle: {   normal: {
                color: '#409DF7' //改变区域颜色
              }},
            smooth:true,
            itemStyle: {
              normal: {
                color: '#409DF7' // 改变线条颜色
              }
            },
          }
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartLineUser.setOption(option);
    },
    chartOrder(){
      this.chartLineOrder = echarts.init(document.getElementById('echartsOrder'))
      var option;
      option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.orderTimeList,
          axisLabel: {
            interval: 0, //设置间隔为0
            rotate:45
          },
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false,  //刻度线
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false,  //刻度线
          },
        },
        tooltip: {
          formatter: function(params) {
            console.log(params)   //打印结果
            return params[0].name + '<br/>' + '出票单数' + ' : ' + params[0].data  + '单'    //根据需要拼接
          },
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'cross' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        series: [
          {
            data: this.echartsData.issueList,
            type: 'line',
            areaStyle: {   normal: {
                color: '#409DF7' //改变区域颜色
              }},
            smooth:true,
            itemStyle: {
              normal: {
                color: '#409DF7' // 改变线条颜色
              }
            },
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartLineOrder.setOption(option);
    },
    toOfficial(){
      this.$router.push('/pc/SaasJoin/official/index')
    },
    toTicketIn(){
      this.$router.push('/pc/SaasJoin/ticketIn/index')
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  .message {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;

    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 20px;

      .list-item {
        width: 24%;
        background: #FFF5E6;
        padding: 24px;
        position: relative;

        .number {
          font-size: 32px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #FFAE2B;
          line-height: 44px;
        }

        .text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #FFAE2B;
          line-height: 20px;
          margin-top: 6px;
        }
        .img{
          position: absolute;
          right: 0;
          bottom: 0;
          width: 80px;
          height: 80px;
        }
        .icon{
          width: 24px;
          height: 24px;
        }
      }

      .list-box {
        width: 24%;
        height: 162px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #E8E8E8;

        .list-box-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 13px 16px;
          background: #FAFAFA;
          border-radius: 4px 4px 0px 0px;

          .top-text {
            font-size: 16px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #666666;
            line-height: 22px;
          }
        }

        .list-box-center {
          margin-top: 24px;
          margin-left: 16px;

          .center-num {
            font-size: 28px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #222222;
            line-height: 38px;

            span {
              font-size: 14px;
            }
          }

          .center-text {
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #666666;
            line-height: 20px;

            span {
              color: #30B583;
            }

            img {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      .flex-box {
        width: 49%;
        background: #FAFAFA;
        border-radius: 4px;
        padding: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;

          .left-message {
            margin-left: 20px;

            .title {
              font-size: 20px;
              font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
              font-weight: normal;
              color: #222222;
              line-height: 27px;
            }

            .text {
              font-size: 14px;
              font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
              font-weight: normal;
              color: #666666;
              line-height: 20px;
            }
          }

          img {
            width: 60px;
            height: 60px;
          }
        }

        .right {

          img {
            width: 16px;
            height: 16px;
          }

          .right-button {
            width: 120px;
            height: 36px;
            background: #FF8622;
            border-radius: 2px;
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 36px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }

  .bottom {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bottom-message {
      width: 49%;
      padding: 23px 20px;
      background: #FFFFFF;
      border-radius: 8px;
      .bottom-message-top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .text{
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #666666;
          line-height: 22px;
        }
        .select{
          display: flex;
          align-items: center;
          .select-div{
            border: 1px solid #F0F1F5;
            padding: 7px 16px;
            font-size: 12px;
            font-family: FZLTHJW--GB1-0, FZLTHJW--GB1;
            font-weight: normal;
            color: #666666;
            line-height: 14px;
            cursor: pointer;
          }
          .active{
            border: 1px solid #FF8622!important;
            color: #FF8622!important;
          }
        }
      }
      .echarts-box{
        width: 100%;
        height: 364px;
      }
    }
  }
}
.flex-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .button{
    width: 76px;
    height: 36px;
    background: #3D9EFC;
    border-radius: 2px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/home/index.vue